module.exports = __webpack_public_path__ + "static/media/icon_remove.276c89b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_remove.svg
// module id = 2420
// module chunks = 7